import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/matco-v2-back/node_modules/next/dist/client/link.js");
